var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M486.598,367.304C502.873,333.648,512,295.891,512,256s-9.127-77.648-25.402-111.304L256,122.435 L25.402,144.696C9.127,178.352,0,216.109,0,256s9.127,77.648,25.402,111.304L256,389.565L486.598,367.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,512c101.493,0,189.19-59.065,230.598-144.696H25.402C66.81,452.935,154.506,512,256,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "443.367,306.252 429.846,316.818 435.714,332.939 421.487,323.346 407.965,333.91  412.693,317.415 398.468,307.819 415.617,307.221 420.349,290.726 426.219,306.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "408.741,246.282 399.65,260.835 410.681,273.977 394.03,269.831 384.936,284.38  383.737,267.263 367.088,263.11 383,256.681 381.804,239.563 392.833,252.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "355.694,201.769 352.128,218.554 366.988,227.134 349.923,228.933 346.355,245.713  339.375,230.039 322.308,231.83 335.062,220.348 328.083,204.674 342.943,213.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "290.622,178.087 293.013,195.08 309.91,198.058 294.488,205.584 296.877,222.576  284.957,210.232 269.531,217.754 277.589,202.601 265.668,190.259 282.568,193.238  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "221.377,178.087 229.434,193.238 246.33,190.257 234.413,202.604 242.466,217.756  227.044,210.232 215.122,222.573 217.513,205.584 202.09,198.062 218.989,195.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "156.305,201.769 169.059,213.252 183.916,204.674 176.939,220.354 189.69,231.834  172.625,230.039 165.643,245.713 162.08,228.93 145.014,227.138 159.874,218.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "103.258,246.282 119.171,252.71 130.197,239.566 129.004,256.687 144.912,263.116  128.263,267.265 127.064,284.38 117.974,269.831 101.323,273.98 112.353,260.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "68.634,306.252 85.786,306.85 91.652,290.728 96.387,307.224 113.534,307.823  99.308,317.419 104.036,333.913 90.516,323.349 76.289,332.942 82.158,316.818  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M486.598,144.696C445.19,59.065,357.493,0,256,0C154.506,0,66.81,59.065,25.402,144.696H486.598z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.d01fcd294ff0bb7b600c5551ab61c905.svg";
export { ForwardRef as ReactComponent };